// extracted by mini-css-extract-plugin
export default {"button":"quantity_button__QhOl2"};